import { LinearMipmapLinearFilter, SRGBColorSpace, TextureLoader, type Texture } from 'three';
import type { Card, Suit } from '../../engine/card.js';

const SUIT_ROW: Record<Suit, number> = { spades: 0, hearts: 1, diamonds: 2, clubs: 3 };
const COLS = 13;
const ROWS = 5;

export interface UV {
  readonly offset: readonly [number, number];
  readonly repeat: readonly [number, number];
}

export function uvForFace(card: Card): UV {
  const col = card.rank - 1;
  const row = SUIT_ROW[card.suit];
  return {
    offset: [col / COLS, 1 - (row + 1) / ROWS],
    repeat: [1 / COLS, 1 / ROWS],
  };
}

export function uvForBack(): UV {
  return {
    offset: [0, 0],
    repeat: [1 / COLS, 1 / ROWS],
  };
}

export async function loadCardAtlas(url = '/img/cards-atlas.webp'): Promise<Texture> {
  const loader = new TextureLoader();
  const tex = await loader.loadAsync(url);
  tex.colorSpace = SRGBColorSpace;
  tex.anisotropy = 16;
  tex.minFilter = LinearMipmapLinearFilter;
  tex.generateMipmaps = true;
  return tex;
}
